import React, { FC } from 'react'
import Tag from '../Tag'
import { OversizeLuggageRequirements } from '../../types'

interface Props {
  requirements: OversizeLuggageRequirements
}

const LuggageTag: FC<Props> = ({ requirements }) => {
  const total = Object.values(requirements).reduce((curr, prev) => curr + prev, 0)

  if (total === 0) {
    return null
  }

  return <Tag icon="luggage">x{total} oversized</Tag>
}

export default LuggageTag
